import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
}));

const UserWhatsappSelect = ({ selectedWhatsappIds, onChange }) => {
	const classes = useStyles();
	const [whatsapps, setWhatsapps] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/whatsapp");
				setWhatsapps(data || []);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={{ marginTop: 6 }}>
			<FormControl fullWidth margin="dense" variant="outlined">
				<InputLabel>Conexões com Acesso</InputLabel>
				<Select
					multiple
					labelWidth={150}
					value={selectedWhatsappIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={selected => (
						<div className={classes.chips}>
							{selected?.length > 0 &&
								selected.map(id => {
									const whatsapp = whatsapps.find(w => w.id === id);
									return whatsapp ? (
										<Chip
											key={id}
											style={{ backgroundColor: whatsapp.color }}
											variant="outlined"
											label={whatsapp.name}
											className={classes.chip}
										/>
									) : null;
								})}
						</div>
					)}
				>
					{whatsapps.map(whatsapp => (
						<MenuItem key={whatsapp.id} value={whatsapp.id}>
							{whatsapp.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default UserWhatsappSelect;
